import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [ready, setReady] = useState(false);
    const [role, setRole] = useState();
    const [panel, setPanel] = useState(localStorage.getItem('panel'));
    const [employeeId, setEmployeeId] = useState('');
    const [loading, setLoading] = useState(false);
    const [uploads, setUploads] = useState([]);
    const [toast, setToast] = useState({show: false});

    return (
        <AuthContext.Provider
            value={{
                auth, setAuth, ready, setReady,
                role, setRole, panel, setPanel, employeeId, setEmployeeId,
                loading, setLoading, toast, setToast, uploads, setUploads
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;